module.exports = __webpack_public_path__ + "img/h-linkedin.b9a4c1fe.svg";